import { ICard } from '../../../types';
import { CARD_ACTION } from '../../../constants/general';
import { getPrettyStatus } from '../../../helpers/cardStatus.helper';

export const shouldDisableCardReissue = (cardObject: ICard) => getPrettyStatus(cardObject) !== CARD_ACTION.PRETTY_STATUS.ACTIVE || cardObject?.reissueCanBeActivated;
